import styled from 'styled-components';

import MotifTabNavigation from '@ey/motif-react-wrapper/TabNavigation';

export default styled(MotifTabNavigation)``;
